module.exports = __webpack_public_path__ + "img/hips.7a2947f7.png";